export enum FlowType {
  EMAIL = 'email',
  SCHEDULE = 'schedule',
}
